module.exports = __webpack_public_path__ + "static/media/pancake.9de8a1d2.svg";